import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import ImageComponent from 'atoms/Image/index';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import NutritionAllergenComponent from 'organisms/NutritionAllergen/Container/NutritionAllergenComponent';
import { isMobileDeviceOnly, getBackgroundImagePath } from 'common/utilities/utils';
import { RESIZE } from 'common/constants/SharedConstants';
import { MORE_INFO } from '../NutritionAllergenConstants/NutritionAllergenConstants';
import { NUTRITION_ALLERGEN_CONSTANTS } from 'organisms/NutritionAllergen/Constants/NutritionAllergenConstant';
import getNutritionAllergenDisclaimer from '@kfc-global/react-shared/redux/Actions/NutritionAllergenDisclaimerAction';
import { getCmsClient } from 'common/utilities/cmsClient';
const NutritionAllergenCard = props => {
  const { dname, contentData, categoryId, customizable, item } = props;
  const [isNutritionShow, setIsNutritionShow] = useState(false);
  const [isMobile, setMobileHeader] = useState(isMobileDeviceOnly(window.innerWidth));
  const { headerData: { pdpBackgroundImage = {} } = {} } = useSelector(
    state => state?.marketConfigReducer?.response || {},
  );
  const pdpbackgroundImageData = getBackgroundImagePath(pdpBackgroundImage);

  const windowResized = () => {
    const isMobileView = isMobileDeviceOnly(window.innerWidth);
    setMobileHeader(isMobileView);
  };
  const dispatch = useDispatch();

  const closeButtonHandler = () => {
    setIsNutritionShow(false);
    dispatch(
      getNutritionAllergenDisclaimer({
        object: getCmsClient(),
        contentFull: {
          content_type: 'supportContent',
          include: '5',
          'fields.title': 'NutritionAllergen',
        },
      }),
    );
  };

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, []);

  let summaryTemplateObject = {
    cardId: categoryId,
    calories: item?.content?.caloricValue,
    servesCount: item?.content?.serves,
    customizable,
    kilojoule: 'KJ',
    allergenDetails: item?.content?.allergenInformation,
    nutritionalDetails: item?.content?.nutritionalInformation,
    imageName: { image: { mainImage: item?.imageName[0]?.value } },
    nutritionDetails: {
      showNutritionAllergenModal: isNutritionShow,
      handleCloseModal: closeButtonHandler,
    },
    pdpCardObject: {
      dName: dname?.[0]?.value,
    },
    imageContainerSize: {
      containerWidth: 500,
      containerHeight: 500,
    },
    pdpbackgroundImageData,
  };

  const openNutritionAllergenPopUP = () => {
    setIsNutritionShow(true);
  };

  return (
    <React.Fragment>
      <div className='nutration-allergen-view'>
        <div>{dname?.[0]?.value}</div>
        <div className='kj-value-and-more-info'>
          <div className='kj-value'>{contentData?.caloricValue ?? '-'}</div>

          {!isMobile ? (
            <div
              data-testid='open-nutrition-allergen-popup'
              className='more-info'
              onClick={() => openNutritionAllergenPopUP()}
            >
              {translateWithI18Next(MORE_INFO)}
            </div>
          ) : (
            <div>
              <ImageComponent
                data-testid='open-nutrition-allergen-popup'
                srcFile={IMAGE_PATH.Polygon}
                onClick={() => openNutritionAllergenPopUP()}
              />
            </div>
          )}
        </div>
      </div>

      {isNutritionShow && (
        <NutritionAllergenComponent
          data-testid='nutrition-allergen-comp'
          closeButtonHandler={closeButtonHandler} //only for test coverage
          isMobile={isMobile}
          summaryData={summaryTemplateObject}
          source={NUTRITION_ALLERGEN_CONSTANTS.SOURCE}
        />
      )}
    </React.Fragment>
  );
};
export default NutritionAllergenCard;
